/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diag-lab-inventory-investigation.reducer';

export const DiagLabInventoryInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagLabInventoryInvestigationEntity = useAppSelector(state => state.diagLabInventoryInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagLabInventoryInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.detail.title">DiagLabInventoryInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.id}</dd>
          <dt>
            <span id="consumedUses">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.consumedUses">Consumed Uses</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.consumedUses}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.timestampEntry}</dd>
          <dt>
            <span id="consumedById">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.consumedById">Consumed By Id</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.consumedById}</dd>
          <dt>
            <span id="consumedByType">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.consumedByType">Consumed By Type</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.consumedByType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.diagLab ? diagLabInventoryInvestigationEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.type">Type</Translate>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.type ? diagLabInventoryInvestigationEntity.type.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.diaglabBill">Diaglab Bill</Translate>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.diaglabBill ? diagLabInventoryInvestigationEntity.diaglabBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.checkout">Checkout</Translate>
          </dt>
          <dd>{diagLabInventoryInvestigationEntity.checkout ? diagLabInventoryInvestigationEntity.checkout.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diag-lab-inventory-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diag-lab-inventory-investigation/${diagLabInventoryInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagLabInventoryInvestigationDetail;
